"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var Header_1 = __importDefault(require("./styledComponents/Header"));
var HeaderText_1 = __importDefault(require("./styledComponents/HeaderText"));
var Content_1 = __importDefault(require("./styledComponents/Content"));
var Toggle_1 = __importDefault(require("./styledComponents/Toggle"));
var Grid_1 = __importDefault(require("../Grid/Grid"));
var AccordionPanel_meta_1 = require("./AccordionPanel.meta");
var Translate_1 = __importDefault(require("../Translate/Translate"));
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var Pill_1 = __importDefault(require("../Pill/Pill"));
var Actions_1 = __importDefault(require("../Actions/Actions"));
var AccordionPanel = /** @class */ (function (_super) {
    __extends(AccordionPanel, _super);
    function AccordionPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = AccordionPanel_meta_1.ACCORDION_PANEL_CATEGORY_KEY;
        _this.componentKey = AccordionPanel_meta_1.ACCORDION_PANEL_COMPONENT_KEY;
        _this.toggleOpen = function () {
            var _a = _this.props, onTogglePanel = _a.onTogglePanel, panelKey = _a.panelKey;
            _this.isOpen = !_this.isOpen;
            if (onTogglePanel) {
                onTogglePanel(panelKey, _this.isOpen);
            }
        };
        _this.isOpen = props.isOpen || false;
        return _this;
    }
    AccordionPanel.prototype.componentDidUpdate = function (previousProps) {
        var isOpen = this.props.isOpen;
        if (isOpen !== undefined && previousProps.isOpen !== isOpen) {
            this.isOpen = isOpen;
        }
    };
    Object.defineProperty(AccordionPanel.prototype, "toggle", {
        get: function () {
            var toggle = this.props.toggle;
            var defaultToggle = {
                show: true,
                align: 'right',
            };
            return __assign(__assign({}, defaultToggle), toggle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccordionPanel.prototype, "toggleIcon", {
        get: function () {
            var align = this.toggle.align;
            var asset = this.isOpen ? 'base.accordionPanel.collapseIcon' : 'base.accordionPanel.expandIcon';
            return (react_1.default.createElement(Toggle_1.default, { "data-align": align, asset: asset }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccordionPanel.prototype, "content", {
        get: function () {
            var _a = this.props, content = _a.content, grid = _a.grid, children = _a.children;
            if (grid) {
                return (react_1.default.createElement(Grid_1.default, __assign({}, grid)));
            }
            return content || children;
        },
        enumerable: true,
        configurable: true
    });
    AccordionPanel.prototype.render = function () {
        var _a = this.props, className = _a.className, heading = _a.heading, headingTooltip = _a.headingTooltip, headingPill = _a.headingPill, headingActions = _a.headingActions;
        var isOpen = this.isOpen;
        var togglePosition = (this.toggle.show && this.toggle.align) || 'none';
        var actionsPosition = (headingActions && headingActions.align) || 'right';
        var pillPosition = (headingPill && headingPill.align) || 'right';
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            react_1.default.createElement(Header_1.default, { "data-is-open": isOpen, onClick: this.toggleOpen },
                togglePosition === 'left' && this.toggleIcon,
                headingActions && actionsPosition === 'left' && react_1.default.createElement(Actions_1.default, __assign({}, headingActions)),
                react_1.default.createElement(HeaderText_1.default, null,
                    headingPill && pillPosition === 'left' && react_1.default.createElement(Pill_1.default, __assign({}, headingPill)),
                    react_1.default.createElement(Translate_1.default, null, heading),
                    headingTooltip && react_1.default.createElement(Tooltip_1.default, __assign({}, headingTooltip)),
                    headingPill && pillPosition === 'right' && react_1.default.createElement(Pill_1.default, __assign({}, headingPill))),
                headingActions && actionsPosition === 'right' && react_1.default.createElement(Actions_1.default, __assign({}, headingActions)),
                togglePosition === 'right' && this.toggleIcon),
            isOpen &&
                react_1.default.createElement(Content_1.default, null, this.content)));
    };
    __decorate([
        mobx_1.observable
    ], AccordionPanel.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.action
    ], AccordionPanel.prototype, "toggleOpen", void 0);
    __decorate([
        mobx_1.computed
    ], AccordionPanel.prototype, "toggle", null);
    __decorate([
        mobx_1.computed
    ], AccordionPanel.prototype, "toggleIcon", null);
    __decorate([
        mobx_1.computed
    ], AccordionPanel.prototype, "content", null);
    AccordionPanel = __decorate([
        mobx_react_1.observer
    ], AccordionPanel);
    return AccordionPanel;
}(shared_1.ComponentBase));
exports.AccordionPanel = AccordionPanel;
exports.default = shared_1.InjectedStyledComponent(AccordionPanel, AccordionPanel_meta_1.ACCORDION_PANEL_CATEGORY_KEY, AccordionPanel_meta_1.ACCORDION_PANEL_COMPONENT_KEY);
